import { api, apiRequest } from '@/lib/api';
import type {
  FiscalRecord,
  FiscalRecordDetail,
  FiscalRecordView,
} from './schemas';

export interface ListFiscalParams {
  month: string;
  cnpjId?: string | null;
}

export interface UploadReportPayload {
  file: File;
}

export interface UpdateReportedValuePayload {
  reportedValue: number;
  notes?: string;
}

export const fiscalApi = {
  list: (params: ListFiscalParams) =>
    api.get<FiscalRecordView[]>('/fiscal', {
      month: params.month,
      cnpjId: params.cnpjId ?? undefined,
    }),

  detail: (id: string) => api.get<FiscalRecordDetail>(`/fiscal/${id}`),

  uploadReport: async (id: string, payload: UploadReportPayload) => {
    const form = new FormData();
    form.append('file', payload.file);
    return apiRequest<{ report: unknown; record: FiscalRecord }>({
      method: 'POST',
      path: `/fiscal/${id}/report`,
      body: form,
    });
  },

  updateReportedValue: (id: string, payload: UpdateReportedValuePayload) =>
    api.patch<FiscalRecord>(`/fiscal/${id}/reported-value`, payload),

  releaseEmission: (id: string, reason: string) =>
    api.post<FiscalRecord>(`/fiscal/${id}/release-emission`, { reason }),

  markPaid: (id: string, paidAt?: string) =>
    api.post<FiscalRecord>(`/fiscal/${id}/mark-paid`, paidAt ? { paidAt } : {}),

  retryNfse: (id: string) => api.post<FiscalRecord>(`/fiscal/${id}/retry-nfse`),
};
